import {API} from '../../Services';

async function StoreOnlineProduct(merchantId,productId){
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product/${productId}`,
        // {headers: { 'Authorization':  `Bearer ${token}`}}
        );
}

async function StoreOnlineLike(merchantId,productId){
    let token =  localStorage.getItem('token');
    return API.post(`/like/product/uid/${productId}/`,{},{headers: { 'Authorization':  `Bearer ${token}`}});
}

export {StoreOnlineProduct,StoreOnlineLike}
